import * as echarts from 'echarts'
import store from '../../../store'
export default{
    // 国内专利分析
    // 1.国内专利趋势
    domesticzltrend:function(){
        let myChart = echarts.init(document.querySelector(".domesticzltrend"));
        let options={
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    label: {
                        backgroundColor: '#6a7985'
                    }
                },
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            legend:{
                icon:"rect",
                right:30
            },
            grid:{
                top:"12%",
                bottom:0,
                left:"4%",
                right:"5%",
                containLabel: true
            },
            xAxis: {
                type: 'category',
                data: store.state.trendTimezl,
                axisLabel:{
                    color:"#000",
                    interval: 0
                }
            },
            yAxis: {
                type: 'value'
            },
            series: [{
                name:"申请量",
                data: store.state.trendApListzlY1,
                type: 'bar',
                itemStyle:{
                    color:"#E8684A"
                },
                label:{
                    show:true,
                    position:"top"
                },
                barMaxWidth:55
            },
            {
                name:"授权量",
                data: store.state.trendApListzlY2,
                type: 'bar',
                itemStyle:{
                    color:"#9270CA"
                },
                label:{
                    show:true,
                    position:"top"
                },
                barMaxWidth:55
            }]
        }
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 2.专利类型构成
    zlType1: function () {
        let myChart = echarts.init(document.querySelector(".zlType1"));
        let options = {
            tooltip: {
                trigger: 'item'
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            legend: {
                orient: 'vertical',
                left: 'left',
                icon: 'circle',
                top: 30,
                formatter: function (name) {
                    let values = []
                    let index = 0
                    store.state.apTyCountzl.forEach((ele, i) => {
                        values.push(ele.value)
                        if (ele.name == name) {
                            index = i
                        }
                    })
                    return name + "：" + values[index]
                }
            },
            series: [
                {
                    type: 'pie',
                    radius: '50%',
                    data: store.state.apTyCountzl,
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    },
                    label: {
                        formatter: "{b}:{c}"
                    },
                    color: ['#73A0FA', '#73DEB3', '#FFAB67'],
                    radius: ['0', '70%'],
                    center: ['55%', '55%']
                }
            ]
        }
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    zlType2: function () {
        let myChart = echarts.init(document.querySelector(".zlType2"));
        let options = {
            tooltip: {
                trigger: 'item'
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            legend: {
                orient: 'vertical',
                left: 'left',
                icon: 'circle',
                top: 30,
                formatter: function (name) {
                    let values = []
                    let index = 0
                    store.state.apTyAuthCountzl.forEach((ele, i) => {
                        values.push(ele.value)
                        if (ele.name == name) {
                            index = i
                        }
                    })
                    return name + "：" + values[index]
                }
            },
            series: [
                {
                    type: 'pie',
                    radius: '50%',
                    data: store.state.apTyAuthCountzl,
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    },
                    label: {
                        formatter: "{b}:{c}"
                    },
                    color: ['#73A0FA', '#73DEB3', '#FFAB67'],
                    radius: ['0', '70%'],
                    center: ['55%', '55%']
                }
            ]
        }
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 申请人构成及趋势
    applyMakeup1:function(){
        let myChart = echarts.init(document.querySelector(".applyMakeup1"));
        let options={
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    label: {
                        backgroundColor: '#6a7985'
                    }
                }
            },
            legend: {
                right:30,
                icon:"rect"
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom:30
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: [
                {
                    type: 'category',
                    boundaryGap: true,
                    data: store.state.trendTimezl
                }
            ],
            yAxis: [
                {
                    type: 'value'
                }
            ],
            series: [
                {
                    name: '工矿企业',
                    type: 'line',
                    color:"#5B8FF9",
                    areaStyle: {
                        color:"rgba(91, 143, 249,.3)"
                    },
                    emphasis: {
                        focus: 'series'
                    },
                    label: {
                        show: true,
                        position: 'top'
                    },
                    lineStyle:{
                        color:"#5B8FF9",
                    },
                    data:store.state.gkcompany ,
                    smooth:true,
        
                },
                {
                    name: '科研院所',
                    type: 'line',
                    color:'#5AD8A6',
                    areaStyle: {
                        color:"rgba(90, 216, 166,.3)"
                    },
                    emphasis: {
                        focus: 'series'
                    },
                    label: {
                        show: true,
                        position: 'top'
                    },
                    lineStyle:{
                        color:"#5AD8A6",
                    },
                    data: store.state.sciencedw,
                    smooth:true,
                },
                {
                    name: '大专院校',
                    type: 'line',
                    color:"#5D7092",
                    areaStyle: {
                        color:'rgba(93, 112, 146,.3)'
                    },
                    emphasis: {
                        focus: 'series'
                    },
                    label: {
                        show: true,
                        position: 'top'
                    },
                    lineStyle:{
                        color:"#5D7092",
                    },
                    data: store.state.dzschool,
                    smooth:true
                },
                {
                    name: '机关团体',
                    type: 'line',
                    color:"#F6BD16",
                    areaStyle: {
                        color:"rgba(246, 189, 22,.3)"
                    },
                    label: {
                        show: true,
                        position: 'top'
                    },
                    emphasis: {
                        focus: 'series'
                    },
                    lineStyle:{
                        color:"#F6BD16",
                    },
        
                    data: store.state.jggroup,
                    smooth:true
                },
                {
                    name: '个人',
                    type: 'line',
                    color:"#E8684A",
                    label: {
                        show: true,
                        position: 'top'
                    },
                    areaStyle: {
                        color:"rgba(232, 104, 74,.3)"
                    },
                    emphasis: {
                        focus: 'series'
                    },
                    lineStyle:{
                        color:"#E8684A",
                    },

                    data: store.state.single,
                    smooth:true
                }
            ]
        }
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    applyMakeup2:function(){
        let myChart = echarts.init(document.querySelector(".applyMakeup2"));
        let options={
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    label: {
                        backgroundColor: '#6a7985'
                    }
                }
            },
            legend: {
                right:30,
                icon:"rect"
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom:30
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: [
                {
                    type: 'category',
                    boundaryGap: true,
                    data: store.state.trendTimezl
                }
            ],
            yAxis: [
                {
                    type: 'value'
                }
            ],
            series: [
                {
                    name: '工矿企业',
                    type: 'line',
                    color:"#5B8FF9",
                    areaStyle: {
                        color:"rgba(91, 143, 249,.3)"
                    },
                    emphasis: {
                        focus: 'series'
                    },
                    label: {
                        show: true,
                        position: 'top'
                    },
                    lineStyle:{
                        color:"#5B8FF9",
                    },
              
                    data: store.state.gkcompanyAuth,
                    smooth:true
                },
                {
                    name: '科研院所',
                    type: 'line',
                    color:"#5AD8A6",
                    areaStyle: {
                        color:"rgba(90, 216, 166,.3)"
                    },
                    label: {
                        show: true,
                        position: 'top'
                    },
                    emphasis: {
                        focus: 'series'
                    },
                    lineStyle:{
                        color:"#5AD8A6",
                    },
                
                    data: store.state.sciencedwAuth,
                    smooth:true
                },
                {
                    name: '大专院校',
                    type: 'line',
                    color:"#5D7092",
                    areaStyle: {
                        color:'rgba(93, 112, 146,.3)'
                    },
                    emphasis: {
                        focus: 'series'
                    },
                    label: {
                        show: true,
                        position: 'top'
                    },
                    lineStyle:{
                        color:"#5D7092",
                    },
        
                    data: store.state.dzschoolAuth,
                    smooth:true
                },
                {
                    name: '机关团体',
                    type: 'line',
                    color:"#F6BD16",
                    areaStyle: {
                        color:"rgba(246, 189, 22,.3)"
                    },
                    label: {
                        show: true,
                        position: 'top'
                    },
                    emphasis: {
                        focus: 'series'
                    },
                    lineStyle:{
                        color:"#F6BD16",
                    },
                
                    data: store.state.jggroupAuth,
                    smooth:true
                },
                {
                    name: '个人',
                    type: 'line',
                    color:"#E8684A",
                    label: {
                        show: true,
                        position: 'top'
                    },
                    areaStyle: {
                        color:"rgba(232, 104, 74,.3)"
                    },
                    emphasis: {
                        focus: 'series'
                    },
                    lineStyle:{
                        color:"#E8684A",
                    },
              
                    data: store.state.singleAuth,
                    smooth:true
                }
            ]
        }
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // IPC技术分类Top10
    ipcTecnicType1: function () {
        let myChart = echarts.init(document.querySelector(".ipcTecnicType1"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {}
                },
                bottom: 10
            },
            grid: {
                left: '2%',
                top: '8%',
                right: '3%',
                bottom: '2%',
                containLabel: true,
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisTick: {
                    show: false
                },
                axisLabel: {
                    formatter: function () {
                        return "";
                    }
                }
            },
            yAxis: {
                type: 'category',
                axisTick: {
                    show: false
                },
                data: store.state.ipcCountYzl,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#000",
                    formatter: function (params) {
                        var val = ""
                        if (params.length > 10) {
                            val = params.substr(0, 10) + "..."
                            return val
                        } else {
                            return params
                        }
                    }
                },
                inverse: true
            },
            series: [
                {
                    type: 'bar',
                    data: store.state.ipcCountXzl,
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#3370ed'
                            }, {
                                offset: 1,
                                color: '#94c2fd'

                            }])
                        }
                    },
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    ipcTecnicType2: function () {
        let myChart = echarts.init(document.querySelector(".ipcTecnicType2"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            grid: {
                left: '2%',
                top: '8%',
                right: '3%',
                bottom: '2%',
                containLabel: true,
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisTick: {
                    show: false
                },
                axisLabel: {
                    formatter: function () {
                        return "";
                    }
                }
            },
            yAxis: {
                type: 'category',
                axisTick: {
                    show: false
                },
                data: store.state.ipcAuthCountYzl,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#000",
                    formatter: function (params) {
                        var val = ""
                        if (params.length > 10) {
                            val = params.substr(0, 10) + "..."
                            return val
                        } else {
                            return params
                        }
                    }
                },
                inverse: true
            },
            series: [
                {
                    type: 'bar',
                    data: store.state.ipcAuthCountXzl,
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#3370ed'
                            }, {
                                offset: 1,
                                color: '#94c2fd'

                            }])
                        }
                    },
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 有效专利权利人分布
        rightIntener1:function(){
            let myChart = echarts.init(document.querySelector(".rightIntener1"));
            let options = {
                tooltip: {
                    trigger: 'item'
                },
                toolbox: {
                    feature: {
                        saveAsImage: {
                            title:false
                        }
                    },
                    bottom: 10
                },
                legend: {
                    orient: 'vertical',
                    left: 'left',
                    icon: 'circle',
                    top: 30,
                    formatter: function (name) {
                        let values = []
                        let index = 0
                        store.state.apValid.forEach((ele, i) => {
                            values.push(ele.value)
                            if (ele.name == name) {
                                index = i
                            }
                        })
                        return name + "：" + values[index]
                    }
                },
                series: [
                    {
                        type: 'pie',
                        radius: '50%',
                        data: store.state.apValid,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        },
                        label: {
                            formatter: "{b}:{c}"
                        },
                        color: ['#5B8FF9', '#5AD8A6', '#5D7092', '#F6BD16', '#E8684A'],
                        radius: ['0', '70%'],
                        center: ['55%', '55%']
                    }
                ]
            }
            myChart.setOption(options);
            window.addEventListener('resize', () => {
                myChart.resize()
            })
        },
    // rightIntener1:function(){
    //     let myChart = echarts.init(document.querySelector(".rightIntener1"));
    //     let options={
    //         tooltip: {
    //             trigger: 'axis',
    //             axisPointer: {
    //                 type: 'cross',
    //                 label: {
    //                     backgroundColor: '#6a7985'
    //                 }
    //             }
    //         },
    //         legend: {
    //             right:30,
    //             icon:"rect"
    //         },
    //         toolbox: {
    //             feature: {
    //                 saveAsImage: {
    //                     title:false
    //                 }
    //             },
    //             bottom:30
    //         },
    //         grid: {
    //             left: '3%',
    //             right: '4%',
    //             bottom: '3%',
    //             containLabel: true
    //         },
    //         xAxis: [
    //             {
    //                 type: 'category',
    //                 boundaryGap: true,
    //                 data: store.state.trendTimezl
    //             }
    //         ],
    //         yAxis: [
    //             {
    //                 type: 'value'
    //             }
    //         ],
    //         series: [
    //             {
    //                 name: '工矿企业',
    //                 type: 'line',
    //                 color:"#228F6A",
    //                 areaStyle: {
    //                     color:"rgba(34, 143, 106,.3)"
    //                 },
    //                 label: {
    //                     show: true,
    //                     position: 'top'
    //                 },
    //                 emphasis: {
    //                     focus: 'series'
    //                 },
    //                 lineStyle:{
    //                     color:"#228F6A",
    //                 },
                   
    //                 data:store.state.gkcompanyYX ,
    //                 smooth:true
    //             },
    //             {
    //                 name: '科研院所',
    //                 type: 'line',
    //                 color:"#E8684A",
    //                 areaStyle: {
    //                     color:"rgba(232, 104, 74,.3)"
    //                 },
    //                 label: {
    //                     show: true,
    //                     position: 'top'
    //                 },
    //                 emphasis: {
    //                     focus: 'series'
    //                 },
    //                 lineStyle:{
    //                     color:"#E8684A",
    //                 },
   
    //                 data: store.state.sciencedwYX,
    //                 smooth:true
    //             },
    //             {
    //                 name: '大专院校',
    //                 type: 'line',
    //                 color:"#6DC8EC",
    //                 areaStyle: {
    //                     color:'rgba(109, 200, 236,.3)'
    //                 },
    //                 label: {
    //                     show: true,
    //                     position: 'top'
    //                 },
    //                 emphasis: {
    //                     focus: 'series'
    //                 },
    //                 lineStyle:{
    //                     color:"#6DC8EC",
    //                 },
          
    //                 data: store.state.dzschoolYX,
    //                 smooth:true
    //             },
    //             {
    //                 name: '机关团体',
    //                 type: 'line',
    //                 color:"#5A73D8",
    //                 areaStyle: {
    //                     color:"rgba(90, 115, 216,.3)"
    //                 },
    //                 label: {
    //                     show: true,
    //                     position: 'top'
    //                 },
    //                 emphasis: {
    //                     focus: 'series'
    //                 },
    //                 lineStyle:{
    //                     color:"#5A73D8",
    //                 },
               
    //                 data: store.state.jggroupYX,
    //                 smooth:true
    //             },
    //             {
    //                 name: '个人',
    //                 type: 'line',
    //                 color:"#F6BD16",
    //                 label: {
    //                     show: true,
    //                     position: 'top'
    //                 },
    //                 areaStyle: {
    //                     color:"rgba(246, 189, 22,.3)"
    //                 },
    //                 emphasis: {
    //                     focus: 'series'
    //                 },
    //                 lineStyle:{
    //                     color:"#F6BD16",
    //                 },
              
    //                 data: store.state.singleYX,
    //                 smooth:true
    //             }
    //         ]
    //     }
    //     myChart.setOption(options);
    //     window.addEventListener('resize', () => {
    //         myChart.resize()
    //     })
    // },
    rightIntener2:function(){
        let myChart = echarts.init(document.querySelector(".rightIntener2"));
        let options = {
            tooltip: {
                trigger: 'item'
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            legend: {
                orient: 'vertical',
                left: 'left',
                icon: 'circle',
                top: 30,
                formatter: function (name) {
                    let values = []
                    let index = 0
                    store.state.utilityValidInvzl.forEach((ele, i) => {
                        values.push(ele.value)
                        if (ele.name == name) {
                            index = i
                        }
                    })
                    return name + "：" + values[index]
                }
            },
            series: [
                {
                    type: 'pie',
                    radius: '50%',
                    data: store.state.utilityValidInvzl,
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    },
                    label: {
                        formatter: "{b}:{c}"
                    },
                    color: ['#5B8FF9', '#5AD8A6', '#5D7092', '#F6BD16', '#E8684A'],
                    radius: ['0', '70%'],
                    center: ['55%', '55%']
                }
            ]
        }
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    rightIntener3:function(){
        let myChart = echarts.init(document.querySelector(".rightIntener3"));
        let options = {
            tooltip: {
                trigger: 'item'
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            legend: {
                orient: 'vertical',
                left: 'left',
                icon: 'circle',
                top: 30,
                formatter: function (name) {
                    let values = []
                    let index = 0
                    store.state.designValidInvzl.forEach((ele, i) => {
                        values.push(ele.value)
                        if (ele.name == name) {
                            index = i
                        }
                    })
                    return name + "：" + values[index]
                }
            },
            series: [
                {
                    type: 'pie',
                    radius: '50%',
                    data: store.state.designValidInvzl,
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    },
                    label: {
                        formatter: "{b}:{c}"
                    },
                    color: ['#5B8FF9', '#5AD8A6', '#5D7092', '#F6BD16', '#E8684A'],
                    radius: ['0', '70%'],
                    center: ['55%', '55%']
                }
            ]
        }
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
// 专利质押量
   
   patentdj: function () {
    let myChart = echarts.init(document.querySelector(".patentdj"));
    let options = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'cross',
                label: {
                    backgroundColor: '#6a7985'
                }
            },
        },
        legend: {
            show: true,
            icon: 'rect',
            right: 30
        },
        toolbox: {
            feature: {
                saveAsImage: {
                    title:false
                }
            },
            bottom: 10
        },
        grid: {
            left: '2%',
            top: '10%',
            right: '3%',
            bottom: '5%',
            containLabel: true,
        },
        xAxis: {
            type: 'category',
            boundaryGap: true,
            data: store.state.trendTimezl,
            axisTick: {
                show: false
            },
            axisLine: {
                lineStyle: {
                    color: "#ddd",
                    width: 2
                }
            },
            axisLabel: {
                fontSize: 12,
                color: "#000"
            },
        },
        yAxis: {
            type: 'value',
            axisTick: {
                show: false
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: "#ddd",
                    width: 2
                }
            },
            axisLabel: {
                fontSize: 12,
                color: "#ddd"
            },
        },
        series: [{
            name: '专利质押登记量',
            data: store.state.patentPledgeOneY,
            type: 'line',
            areaStyle: {
                color: 'rgba(250, 100, 0,.3)'
            },
            color: '#FA6400',
            smooth: true,
            label: {
                show: true,
                color: "#000",
                position: 'top'
            },
           
            lineStyle: {
                normal: {
                    color: '#FA6400',
                    width: 2
                }

            },
        }]
    }
    myChart.setOption(options);
    window.addEventListener('resize', () => {
        myChart.resize()
    })
},
   // 专利转让量
   patentzhuanrang: function () {
    let myChart = echarts.init(document.querySelector(".patentzhuanrang"));
    let options = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'cross',
                label: {
                    backgroundColor: '#6a7985'
                }
            },
        },
        legend: {
            show: true,
            icon: 'rect',
            right: 30
        },
        toolbox: {
            feature: {
                saveAsImage: {
                    title:false
                }
            },
            bottom: 10
        },
        grid: {
            left: '2%',
            top: '10%',
            right: '3%',
            bottom: '5%',
            containLabel: true,
        },
        xAxis: {
            type: 'category',
            boundaryGap: true,
            data: store.state.trendTimezl,
            axisTick: {
                show: false
            },
            axisLine: {
                lineStyle: {
                    color: "#ddd",
                    width: 2
                }
            },
            axisLabel: {
                fontSize: 12,
                color: "#000"
            },
        },
        yAxis: {
            type: 'value',
            axisTick: {
                show: false
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: "#ddd",
                    width: 2
                }
            },
            axisLabel: {
                fontSize: 12,
                color: "#ddd"
            },
        },
        series: [{
            name: '专利核准转让量',
            data: store.state.patentAssignmentsTwoY,
            type: 'line',
            areaStyle: {
                color: 'rgba(90, 115, 216,.3)'
            },
            color: '#5A73D8',
            smooth: true,
            label: {
                show: true,
                color: "#000",
                position: 'top'
            },
           
            lineStyle: {
                normal: {
                    color: '#5A73D8',
                    width: 2
                }

            },
        }]
    }
    myChart.setOption(options);
    window.addEventListener('resize', () => {
        myChart.resize()
    })
},
// 专利许可备案量趋势
   
patentxuke: function () {
    let myChart = echarts.init(document.querySelector(".patentxuke"));
    let options = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'cross',
                label: {
                    backgroundColor: '#6a7985'
                }
            },
        },
        legend: {
            show: true,
            icon: 'rect',
            right: 30
        },
        toolbox: {
            feature: {
                saveAsImage: {
                    title:false
                }
            },
            bottom: 10
        },
        grid: {
            left: '2%',
            top: '10%',
            right: '3%',
            bottom: '5%',
            containLabel: true,
        },
        xAxis: {
            type: 'category',
            boundaryGap: true,
            data: store.state.trendTimezl,
            axisTick: {
                show: false
            },
            axisLine: {
                lineStyle: {
                    color: "#ddd",
                    width: 2
                }
            },
            axisLabel: {
                fontSize: 12,
                color: "#000"
            },
        },
        yAxis: {
            type: 'value',
            axisTick: {
                show: false
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: "#ddd",
                    width: 2
                }
            },
            axisLabel: {
                fontSize: 12,
                color: "#ddd"
            },
        },
        series: [{
            name: '专利许可备案量',
            data: store.state.patentlicensethreeY,
            type: 'line',
            areaStyle: {
                color: 'rgba(93, 112, 146,.3)'
            },
            color: '#5D7092',
            smooth: true,
            label: {
                show: true,
                color: "#000",
                position: 'top'
            },
           
            lineStyle: {
                normal: {
                    color: '#5D7092',
                    width: 2
                }

            },
        }]
    }
    myChart.setOption(options);
    window.addEventListener('resize', () => {
        myChart.resize()
    })
},



    // 国内专利分析榜单
    domesticzltop1: function () {
        let myChart = echarts.init(document.querySelector(".domesticzltop1"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {}
                },
                bottom: 20
            },
            grid: {
                left: '2%',
                top: '8%',
                right: '3%',
                bottom: '2%',
                containLabel: true,
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                show: true,
                axisTick: {
                    show: true,
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                }

            },
            yAxis: {
                type: 'category',
                data: store.state.appTop10Yzl,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#000",
                    formatter: function (params) {
                        var val = ""
                        if (params.length > 10) {
                            val = params.substr(0, 10) + "..."
                            return val
                        } else {
                            return params
                        }
                    }

                },
                inverse: true

            },
            series: [
                {
                    type: 'bar',
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#5ba1ff'
                            }, {
                                offset: 1,
                                color: '#2dc9fd'

                            }])
                        }
                    },
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    data: store.state.appTop10Xzl,
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    domesticzltop2: function () {
        let myChart = echarts.init(document.querySelector(".domesticzltop2"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {}
                },
                bottom: 20
            },
            grid: {
                left: '2%',
                top: '8%',
                right: '3%',
                bottom: '2%',
                containLabel: true,
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                show: true,
                axisTick: {
                    show: true,
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                }

            },
            yAxis: {
                type: 'category',
                data: store.state.authTop10Yzl,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#000",
                    formatter: function (params) {
                        var val = ""
                        if (params.length > 10) {
                            val = params.substr(0, 10) + "..."
                            return val
                        } else {
                            return params
                        }
                    }
                },
                inverse: true

            },
            series: [
                {
                    type: 'bar',
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#5ba1ff'
                            }, {
                                offset: 1,
                                color: '#2dc9fd'

                            }])
                        }
                    },
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    data: store.state.authTop10Xzl,
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    domesticzltop3: function () {
        let myChart = echarts.init(document.querySelector(".domesticzltop3"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {}
                },
                bottom: 20
            },
            grid: {
                left: '2%',
                top: '8%',
                right: '3%',
                bottom: '2%',
                containLabel: true,
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                show: true,
                axisTick: {
                    show: true,
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                }

            },
            yAxis: {
                type: 'category',
                data: store.state.validTop10Yzl,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#000",
                    formatter: function (params) {
                        var val = ""
                        if (params.length > 10) {
                            val = params.substr(0, 10) + "..."
                            return val
                        } else {
                            return params
                        }
                    }
                },
                inverse: true,

            },
            series: [
                {
                    type: 'bar',
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#5ba1ff'
                            }, {
                                offset: 1,
                                color: '#2dc9fd'

                            }])
                        }
                    },
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    data: store.state.validTop10Xzl,
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    domesticzltop4: function () {
        let myChart = echarts.init(document.querySelector(".domesticzltop4"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {}
                },
                bottom: 20
            },
            grid: {
                left: '2%',
                top: '8%',
                right: '3%',
                bottom: '2%',
                containLabel: true,
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                show: true,
                axisTick: {
                    show: true,
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                }

            },
            yAxis: {
                type: 'category',
                data: store.state.notValidTop10Yzl,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#000",
                    formatter: function (params) {
                        var val = ""
                        if (params.length > 10) {
                            val = params.substr(0, 10) + "..."
                            return val
                        } else {
                            return params
                        }
                    }
                },
                inverse: true
            },
            series: [
                {
                    type: 'bar',
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#5ba1ff'
                            }, {
                                offset: 1,
                                color: '#2dc9fd'

                            }])
                        }
                    },
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    data: store.state.notValidTop10Xzl,
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // PCT专利趋势
    pctzltrend: function () {
        let myChart = echarts.init(document.querySelector(".pctzltrend"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    label: {
                        backgroundColor: '#6a7985'
                    }
                },
            },
            legend: {
                show: true,
                icon: 'rect',
                right: 30
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 30
            },
            grid: {
                left: '2%',
                top: '15%',
                right: '8%',
                bottom: '5%',
                containLabel: true,
            },
            xAxis: {
                type: 'category',
                boundaryGap: true,
                data: store.state.trendTimezl,
                axisTick: {
                    show: false
                },
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    fontSize: 10,
                    color: "#000",
                    interval:0
                },
            },
            yAxis: {
                type: 'value',
                axisTick: {
                    show: false
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#000"
                },
            },
            series: [{
                name: '公开量',
                data: store.state.pctTrendCountYzl,
                type: 'line',
                areaStyle: {
                    color: 'rgba(91, 143, 249,.3)'
                },
                label: {
                    show: true,
                    color: "#000",
                    position: 'top'
                },
                smooth: true,
                lineStyle: {
                    normal: {
                        color: '#5B8FF9',
                        width: 2
                    }

                },
            }]
        }
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // IPC分类Top10
    ipcttype: function () {
        let myChart = echarts.init(document.querySelector(".ipcttype"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            legend: {
                right: 30,
                icon: 'rect'
            },
            grid: {
                left: '2%',
                right: '4%',
                bottom: '3%',
                top: "15%",
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    show: false
                },

            },
            yAxis: {
                type: 'category',
                data: store.state.pctIpcTop10Yzl,
                triggerEvent: true,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    color: "#000",
                    formatter: function (params) {
                        var val = ""
                        if (params.length > 10) {
                            val = params.substr(0, 10) + "..."
                            return val
                        } else {
                            return params
                        }
                    }
                },
                inverse: true
            },
            series: [
                {
                    name: '申请量',
                    type: 'bar',
                    data: store.state.pctIpcTop10Xzl,
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#5B8FF9'
                            }, {
                                offset: 1,
                                color: '#94C2FD'

                            }])
                        }
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // PCT公开量Top10
    pctPublictop10: function () {
        let myChart = echarts.init(document.querySelector(".pctPublictop10"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            grid: {
                left: '2%',
                right: '4%',
                bottom: '3%',
                top: "8%",
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    show: false
                },

            },
            yAxis: {
                type: 'category',
                data: store.state.pctTop10CountYzl,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    color: "#000",
                    
                },
                inverse: true
            },
            series: [
                {

                    type: 'bar',
                    data: store.state.pctTop10CountXzl,
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#18A069'
                            }, {
                                offset: 1,
                                color: '#81DB7C'

                            }])
                        }
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 专利状态分析
    zlstatus: function () {
        let myChart = echarts.init(document.querySelector(".zlstatus"));
        let options = {
            tooltip: {
                trigger: 'item'
            },
            toolbox: {
                feature: {
                    saveAsImage: {}
                },
                bottom: 10
            },

            legend: {
                orient: 'vertical',
                left: 'left',
                icon: 'circle',
                top: 40,
                left: 100,
                formatter: function (name) {
                    let values = []
                    let index = 0
                    store.state.ptLawCountzl.forEach((ele, i) => {
                        values.push(ele.value)
                        if (ele.name == name) {
                            index = i
                        }
                    })
                    return name + "：" + values[index]
                }
            },
            series: [
                {

                    type: 'pie',
                    radius: '50%',
                    data: store.state.ptLawCountzl,
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    },
                    color: ['#5B8FF9', '#5AD8A6', '#5D7092', '#F6BD16', '#E8684A'],
                    radius: ['0', '75%'],
                    center: ['50%', '50%'],
                    label: {
                        formatter: "{b}:{c}"
                    },
                }
            ]
        }
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 区域专利比较
    regionzlDCompare1:function(){
        let myChart = echarts.init(document.querySelector(".regionzlDCompare1"));
        let options={
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    label: {
                        backgroundColor: '#6a7985'
                    }
                }
            },
            legend: {
                left:30,
                icon:"rect"
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom:10
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: [
                {
                    type: 'category',
                    boundaryGap: true,
                    data: store.state.ApplyXzl,
                    axisLabel:{
                        interval:0
                    }
                },
                // axisLabel:{
                //     interval:0
                // },
            ],
            yAxis: [
                {
                    type: 'value'
                }
            ],
            series: [
                {
                    name: '发明',
                    type: 'line',
                    emphasis: {
                        focus: 'series'
                    },
                    color:"#5B8FF9",
                    areaStyle: {
                        color:"rgba(91, 143, 249,.3)"
                    },
             
                    data: store.state.ApplyFM,
                    smooth:true,
                    label:{
                        show:true,
                        position:"top"
                    }
                },
                {
                    name: '实用新型',
                    type: 'line',
                    emphasis: {
                        focus: 'series'
                    },
                    color:"#5AD8A6",
              
                    areaStyle: {
                        color:"rgba(90, 216, 166,.3) "
                    },
                    data: store.state.ApplySY,
                    smooth:true,
                    label:{
                        show:true,
                        position:"top"
                    }
                },
                
                {
                    name: '外观设计',
                    type: 'line',
                    emphasis: {
                        focus: 'series'
                    },
                    color:"#5D7092",
                  
                    areaStyle: {
                        color:"rgba(93, 112, 146,.3)"
                    },
                    data: store.state.ApplyWG,
                    smooth:true,
                    label:{
                        show:true,
                        position:"top"
                    }
                },
            ]
        }
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    }, 
    regionzlDCompare2:function(){
        let myChart = echarts.init(document.querySelector(".regionzlDCompare2"));
        let options={
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    label: {
                        backgroundColor: '#6a7985'
                    }
                }
            },
            legend: {
                left:30,
                icon:"rect"
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom:10
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: [
                {
                    type: 'category',
                    boundaryGap: true,
                    data: store.state.AuthXzl
                }
            ],
            yAxis: [
                {
                    type: 'value'
                }
            ],
            series: [
                {
                    name: '发明',
                    type: 'line',
                    emphasis: {
                        focus: 'series'
                    },
                    color:"#5B8FF9",
                
                    areaStyle: {
                        color:"rgba(91, 143, 249,.3)"
                    },
                    data: store.state.AuthFM,
                    smooth:true,
                    label:{
                        show:true,
                        position:"top"
                    }
                },
                {
                    name: '实用新型',
                    type: 'line',
                    emphasis: {
                        focus: 'series'
                    },
                    color:"#5AD8A6",
                  
                    areaStyle: {
                        color:"rgba(90, 216, 166,.3) "
                    },
                    data: store.state.AuthSY,
                    smooth:true,
                    label:{
                        show:true,
                        position:"top"
                    }
                },
                
                {
                    name: '外观设计',
                    type: 'line',
                    emphasis: {
                        focus: 'series'
                    },
                    color:"#5D7092",
             
                    areaStyle: {
                        color:"rgba(93, 112, 146,.3)"
                    },
                    data: store.state.AuthWG,
                    smooth:true,
                    label:{
                        show:true,
                        position:"top"
                    }
                },
            ]
        }
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    }, 
    regionzlDCompare3:function(){
        let myChart = echarts.init(document.querySelector(".regionzlDCompare3"));
        let options={
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    label: {
                        backgroundColor: '#6a7985'
                    }
                }
            },
            legend: {
                left:30,
                icon:"rect"
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom:10
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: [
                {
                    type: 'category',
                    boundaryGap: true,
                    data: store.state.pctXzl
                }
            ],
            yAxis: [
                {
                    type: 'value'
                }
            ],
            series: [
                {
                    name: '发明',
                    type: 'line',
                    emphasis: {
                        focus: 'series'
                    },
                    color:"#5B8FF9",
               
                    areaStyle: {
                        color:"rgba(91, 143, 249,.3)"
                    },
                    data: store.state.pctFM,
                    smooth:true,
                    label:{
                        show:true,
                        position:"top"
                    }
                },
                {
                    name: '实用新型',
                    type: 'line',
                    emphasis: {
                        focus: 'series'
                    },
                    color:"#5AD8A6",
               
                    areaStyle: {
                        color:"rgba(90, 216, 166,.3) "
                    },
                    data: store.state.pctSY,
                    smooth:true,
                    label:{
                        show:true,
                        position:"top"
                    }
                }
            ]
        }
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    }, 
    regionzlDCompare4:function(){
        let myChart = echarts.init(document.querySelector(".regionzlDCompare4"));
        let options={
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    label: {
                        backgroundColor: '#6a7985'
                    }
                }
            },
            legend: {
                left:30,
                icon:"rect"
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom:10
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: [
                {
                    type: 'category',
                    boundaryGap: true,
                    data: store.state.wxXzl
                }
            ],
            yAxis: [
                {
                    type: 'value'
                }
            ],
            series: [
                {
                    name: '发明',
                    type: 'line',
                    emphasis: {
                        focus: 'series'
                    },
                    color:"#5B8FF9",
                   
                    areaStyle: {
                        color:"rgba(91, 143, 249,.3)"
                    },
                    data: store.state.wxFM,
                    smooth:true,
                    label:{
                        show:true,
                        position:"top"
                    }
                },
                {
                    name: '实用新型',
                    type: 'line',
                    emphasis: {
                        focus: 'series'
                    },
                    color:"#5AD8A6",
                    
                    areaStyle: {
                        color:"rgba(90, 216, 166,.3) "
                    },
                    data: store.state.wxSY,
                    smooth:true,
                    label:{
                        show:true,
                        position:"top"
                    }
                },
                
                {
                    name: '外观设计',
                    type: 'line',
                    emphasis: {
                        focus: 'series'
                    },
                    color:"#5D7092",
                  
                    areaStyle: {
                        color:"rgba(93, 112, 146,.3)"
                    },
                    data: store.state.wxWG,
                    smooth:true,
                    label:{
                        show:true,
                        position:"top"
                    }
                },
            ]
        }
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    }, 
}